export const AUTH_KEY = "boatokuman.token";
export const USER_KEY = "boatokuman.user";

export function setAuth(token: string, user: any) {
  localStorage.setItem(AUTH_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user || {}));
}

export function getToken() {
  return localStorage.getItem(AUTH_KEY);
}

export function getUser() {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || "{}");
  } catch {
    return {};
  }
}

export function clearAuth() {
  localStorage.removeItem(AUTH_KEY);
  localStorage.removeItem(USER_KEY);
}
